"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingStyle = void 0;
const typestyle_1 = require("typestyle");
const loadingStyle = () => ({
    position: 'relative',
    width: '100%',
    height: '100%',
    opacity: 1,
    transition: 'opacity 2s ease, z-index 1s linear',
    zIndex: 30
});
exports.LoadingStyle = (0, typestyle_1.stylesheet)({
    loading: Object.assign({}, loadingStyle()),
    loadingHidden: Object.assign(Object.assign({}, loadingStyle()), { opacity: 0, userSelect: 'none', zIndex: 0 }),
    spinner: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        marginLeft: '-40px',
        marginTop: '-40px',
        animation: 'rotate 1s linear 0s infinite',
        height: '80px',
        width: '80px',
        animationName: (0, typestyle_1.keyframes)({
            from: { transform: 'rotate(0deg)' },
            to: { transform: 'rotate(360deg)' }
        })
    },
    log: {
        position: 'absolute',
        background: 'rgba(0,0,0,0.4)',
        padding: '10px',
        fontFamily: 'monospace',
        margin: '0',
        top: '16px',
        right: 0,
        paddingLeft: '16px',
        listStyle: 'none'
    },
    logItem: {
        display: 'block'
    }
});
